import { useEffect, useRef } from 'react';
import type React from 'react';

import { useIsAllowedByCookiePrefs, useIsAllowedForLocation } from './hooks';
import { initMetaPixelScript } from './initMetaPixelScript';

export const MetaPixel: React.FC = () => {
	const pixelInitialized = useRef(false);
	const {
		data: { isAllowedByCookiePrefs },
	} = useIsAllowedByCookiePrefs();
	const {
		data: { isAllowedForLocation },
	} = useIsAllowedForLocation();
	const metaPixelEnabled = isAllowedByCookiePrefs && isAllowedForLocation;

	useEffect(() => {
		if (metaPixelEnabled && !pixelInitialized.current) {
			initMetaPixelScript();
			pixelInitialized.current = true;
		}
	}, [metaPixelEnabled]);

	return null;
};
